import { render, staticRenderFns } from "./promotional-discounts-add.vue?vue&type=template&id=1771b786&scoped=true"
import script from "./promotional-discounts-add.vue?vue&type=script&lang=js"
export * from "./promotional-discounts-add.vue?vue&type=script&lang=js"
import style0 from "./promotional-discounts-add.vue?vue&type=style&index=0&id=1771b786&prod&scoped=true&lang=css"
import style1 from "./promotional-discounts-add.vue?vue&type=style&index=1&id=1771b786&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1771b786",
  null
  
)

export default component.exports